export const envVars = {
    apiBasePath: import.meta.env.VITE_API_URL as string
};
